import { PaymentStatus } from "~/gql/graphqlBase.generated";
import { PAYMENT_STATUS_COLORS } from "~/helpers/statusChip";
import i18n from "~/i18n/i18n";

export interface PaymentStatusChip {
	color: "default" | "error" | "info" | "success" | "warning";
	label: string;
}

const PAYMENT_STATUS_CHIPS: Record<PaymentStatus, { color: PaymentStatusChip["color"]; labelKey: string }> = {
	[PaymentStatus.Unpaid]: {
		color: PAYMENT_STATUS_COLORS[PaymentStatus.Unpaid],
		labelKey: "orders.paymentStatus.unpaid"
	},
	[PaymentStatus.PartiallyPaid]: {
		color: PAYMENT_STATUS_COLORS[PaymentStatus.PartiallyPaid],
		labelKey: "orders.paymentStatus.partiallyPaid"
	},
	[PaymentStatus.Paid]: { color: PAYMENT_STATUS_COLORS[PaymentStatus.Paid], labelKey: "orders.paymentStatus.paid" },
	[PaymentStatus.Overpaid]: {
		color: PAYMENT_STATUS_COLORS[PaymentStatus.Overpaid],
		labelKey: "orders.paymentStatus.overpaid"
	}
};

const paymentStatusChip = (status: PaymentStatus): PaymentStatusChip => {
	const { color, labelKey } = PAYMENT_STATUS_CHIPS[status] ?? PAYMENT_STATUS_CHIPS[PaymentStatus.Unpaid];
	return { color, label: i18n.t(labelKey, { ns: "fulfill" }) };
};

export const formatPaymentStatus = (value: unknown): string =>
	value ? paymentStatusChip(value as PaymentStatus).label : "";

export const resolveHeaderPaymentStatus = (
	paymentStatus: null | PaymentStatus | undefined,
	isSettled: boolean
): null | PaymentStatus => paymentStatus ?? (isSettled ? PaymentStatus.Unpaid : null);

export default paymentStatusChip;
